import type { Api } from 'common/db/api/paths';
import { getDomainNamePublicSuffix, removePublicSuffixFromDomainName } from './parse';

export const getIsValidDomainName = (domainName: string): boolean => {
	/**
	 *  Based on: https://vaghasiyaharryk.medium.com/how-to-validate-a-domain-name-using-regular-expression-9ab484a1b430
	 *  ^ represents the starting of the string.
		(?:[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?\.)+ Can have 1-63 characters, first or last cannot be -. Must end to . and repeat at least once
		[A-Za-z0-9][A-Za-z0-9-]{0,61}[A-Za-z0-9] TLD part must be 2-63 characters long
		$ represents the ending of the string.
	 */
	const validDomanRegexp = /^(?:[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?\.)+[A-Za-z0-9][A-Za-z0-9-]{0,61}[A-Za-z0-9]$/;
	return validDomanRegexp.test(domainName);
};

export const getIsFreeCustomDomainName = async (api: Api, domainName: string) => {
	const existingDomains = await api.shopUrls.get
		.whereArray('customDomains', 'array-contains', domainName)
		.get();
	return !existingDomains.length;
};

export const getIsShopsDomainName = async (api: Api, domainName: string, shopId: string) => {
	const existingDomains = await api.shopUrls.get
		.whereArray('customDomains', 'array-contains', domainName)
		.get();
	return existingDomains[0]?.shopId === shopId;
};

export const getIsSubDomain = async (domainName: string): Promise<boolean> => {
	if (!getIsValidDomainName(domainName)) {
		return false;
	}
	const { default: publicSuffixList } = await import(
		'common/services/publicSuffixList/public-suffix.json'
	);
	const publicSuffix = getDomainNamePublicSuffix(domainName, publicSuffixList);
	const domainNameWithoutPublicSuffix = removePublicSuffixFromDomainName(domainName, publicSuffix);
	const parts = domainNameWithoutPublicSuffix.split('.');
	return parts.length > 1 && parts[parts.length - 2] !== 'www';
};
